
import { Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, TextField, Snackbar, Alert } from "@mui/material";
import MuiAlert from '@mui/material/Alert';
import React, { useState } from 'react';
import { auth } from '../../firebase';
import { selectUser } from '../../features/auth/authSlice';
import { useSelector } from 'react-redux';
import { EmailAuthProvider, reauthenticateWithCredential } from "firebase/auth";

export default function ReAuthDeleteDialog(props)
{
	const {handleDelete = ()=>{},selectionSize = 2, handleError = ()=>{}} = props;
	const [open, setOpen] = useState(false);

	const [password, setPassword] = useState("");
	const handlePasswordChange = (e) => {
		setPassword(e.target.value);
	};

	const handleClose = () => {
		setPassword("");
		setOpen(false);
	};

	const handleOpen = () => {
		if (selectionSize > 0) {
			setOpen(true);
		}
	}

	const [openErrorSnack, setOpenErrorSnack] = useState(false);
	const handleErrorSnackClose = ()=>
	{
		setOpenErrorSnack(false);
	}

	// const [openSnack, setOpenSnack] = useState(false);
	// const handleSnackClose = ()=>
	// {
	// 	setOpenSnack(false);
	// }

	const user = useSelector(selectUser);
	const handleConfirmation = () => {
		reauthenticateWithCredential(auth.currentUser, EmailAuthProvider.credential(user.email,password)).then(
			(rsp) => {handleDelete();}
		).catch(
			(err) => {setOpenErrorSnack(true);console.log(err);}
		).finally(
			()=>{handleClose();}
		);
	}

	return (
		<>
			<Button variant='outlined' size="small" onClick={handleOpen} color="error">Delete</Button>
			{/* <Snackbar open={openSnack} autoHideDuration={5000} onClose={handleSnackClose} anchorOrigin={{ vertical:"top", horizontal:"center" }}>
				<MuiAlert variant="filled" severity="success">
					Deletion success
				</MuiAlert>
			</Snackbar> */}
			<Snackbar open={openErrorSnack} autoHideDuration={5000} onClose={handleErrorSnackClose} anchorOrigin={{ vertical:"top", horizontal:"center" }}>
				<MuiAlert variant="filled" severity="error">
					Deletion failed: Failed to Authenticate!
				</MuiAlert>
			</Snackbar>
			<Dialog open={open} onClose={handleClose}>
				<DialogTitle>Delete Records</DialogTitle>
				<DialogContent>
					<DialogContentText>
						Reauthentication Required. Enter password to delete record{(selectionSize > 1 ? "s" : "")}
					</DialogContentText>
					<TextField
						autoFocus
						margin="dense"
						label="password"
						type="password"
						fullWidth
						variant="outlined"
						onChange={handlePasswordChange}
					/>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose}>Cancel</Button>
					<Button onClick={handleConfirmation} color="error" variant='contained'>DELETE</Button>
				</DialogActions>
			</Dialog>
		</>
	);
}